export default __webpack_public_path__ + "static/stadium-presentation-c6335f5c2c6d5a8d734caacdea813746.png";